module.exports = __webpack_public_path__ + "static/media/bird_fly_1.f2f56c85.png";